/* Essence Elite Scroll-Animation: Video folgt dem Scrollen, Textbeats wandern mit. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ehReady) return;
    root.dataset.ehReady = '1';
    var hero = root.querySelector('[data-eh-hero]');
    var stage = root.querySelector('[data-eh-stage]');
    var video = root.querySelector('[data-eh-video]');
    var mobil = root.querySelector('[data-eh-mobil]');
    var posterLayer = root.querySelector('[data-eh-poster]');
    var ring = root.querySelector('[data-eh-ring]');
    var globulus = root.querySelector('[data-eh-globulus]');
    var dots = [].slice.call(root.querySelectorAll('[data-eh-rail] i'));
    var bandEls = [].slice.call(root.querySelectorAll('.eh__band'));
    var HANDY_ANIM = root.hasAttribute('data-handy-anim');
    var VIDEO_URL = root.getAttribute('data-video') || '';
    var POSTER_URL = root.getAttribute('data-poster') || '';
    if (!hero || !stage || !video) return;

    var clamp = function (v, lo, hi) { return Math.min(hi, Math.max(lo, v)); };
    var smoothstep = function (p, e0, e1) { var t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
    function rng(seed) { var s = seed >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }

    bandEls.forEach(function (band, bi) {
      var h = band.querySelector('[data-split]');
      if (!h) return;
      var mode = h.getAttribute('data-split');
      var em = (h.getAttribute('data-em') || '').toLowerCase();
      var text = h.textContent.trim(), r = rng(1000 + bi * 97);
      var sr = document.createElement('span'); sr.className = 'vh'; sr.textContent = text;
      var vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true');
      var words = text.split(' '), ci = 0, total = text.replace(/\s/g, '').length, spread = 0.55;
      words.forEach(function (word, wi) {
        var w = document.createElement('span'); w.className = 'w';
        if (em && word.toLowerCase().replace(/[.,!?]/g, '') === em) w.classList.add('em');
        w.style.setProperty('--th', (wi / words.length * spread + r() * 0.06).toFixed(3));
        if (mode === 'c') {
          word.split('').forEach(function (ch) {
            var c = document.createElement('span'); c.className = 'c'; c.textContent = ch;
            c.style.setProperty('--th', (ci / total * spread + r() * 0.06).toFixed(3));
            c.style.setProperty('--jx', ((r() - 0.5) * 90).toFixed(1) + 'px');
            c.style.setProperty('--jy', ((r() - 0.5) * 70).toFixed(1) + 'px');
            c.style.setProperty('--jr', ((r() - 0.5) * 40).toFixed(1) + 'deg');
            w.appendChild(c); ci++;
          });
        } else { w.textContent = word; ci += word.length; }
        vis.appendChild(w);
        if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
      });
      h.textContent = ''; h.appendChild(sr); h.appendChild(vis);
    });

    var bands = bandEls.map(function (el) {
      return { el: el, a: parseFloat(el.getAttribute('data-a')), b: parseFloat(el.getAttribute('data-b')),
        ramp: el.getAttribute('data-ramp') ? parseFloat(el.getAttribute('data-ramp')) : null,
        first: false, last: el.hasAttribute('data-settle'), op: -1, k: -1, ks: -1 };
    });
    if (bands.length) bands[0].first = true;
    var edges = bands.map(function (b) { return b.a; });

    function heroProgress() {
      var r = hero.getBoundingClientRect(), range = r.height - window.innerHeight;
      return range <= 0 ? 1 : clamp(-r.top / range, 0, 1);
    }

    /* position:sticky faellt aus, sobald ein Vorfahre eine eigene Scroll-Box
       aufmacht. Genau das tut dieses Theme: body traegt overflow-x:hidden, und
       nach Spezifikation wird overflow-y dadurch zu auto. Die Buehne klebt dann
       nicht, der Held rutscht einfach weg.

       Frueher fiel das erst auf, nachdem der Nutzer 40 Pixel gescrollt hatte
       (checkSticky). Am Desktop ist der Held 4 Bildschirme lang, da faellt der
       Sprung nicht ins Gewicht. Am Handy ist man nach 40 Pixeln schon mitten
       drin — es sah aus, als gaebe es gar keine Animation. Deshalb wird die
       Ersatzschaltung jetzt vorab gesetzt, wenn ein Vorfahre eine Scroll-Box
       ist. Ein Fehlalarm kostet nichts: die Ersatzschaltung ist ohnehin der
       Weg, den dieses Theme am Desktop schon immer geht. */
    var fixedMode = false, stickyChecked = false;
    function stickyGebrochen() {
      var e = stage.parentElement;
      while (e) {
        var cs = getComputedStyle(e);
        if (cs.overflowX !== 'visible' && cs.overflowX !== 'clip') return true;
        if (cs.overflowY !== 'visible' && cs.overflowY !== 'clip') return true;
        if (e === document.documentElement) break;
        e = e.parentElement;
      }
      return false;
    }
    function fixedModeAn() {
      if (fixedMode) return;
      fixedMode = true; stickyChecked = true;
      hero.classList.add('is-fixedmode');
      applyFixedMode();
    }
    function checkSticky() {
      if (stickyChecked || fixedMode) return;
      var r = hero.getBoundingClientRect();
      if (r.top < -40 && r.bottom > window.innerHeight + 40) {
        stickyChecked = true;
        if (Math.abs(stage.getBoundingClientRect().top) > 4) { fixedMode = true; hero.classList.add('is-fixedmode'); }
      }
    }
    function applyFixedMode() {
      if (!fixedMode) return;
      var r = hero.getBoundingClientRect();
      hero.classList.toggle('is-pinned', r.top <= 0 && r.bottom >= window.innerHeight);
      hero.classList.toggle('is-past', r.bottom < window.innerHeight);
    }

    /* Gescrubbt wird immer genau ein Video: am Desktop das Breitbild, im
       Hochformat die kurze Fassung in der Karte. aktivesVideo zeigt darauf;
       steht es auf null, wird gar nicht gesprungen (siehe Notbremse unten). */
    var aktivesVideo = video;
    var seekBusy = false, pendingTime = null, seekStart = 0;
    function requestSeek(t) {
      var v = aktivesVideo;
      if (!v || !v.duration) return;
      if (seekBusy) { pendingTime = t; return; }
      seekBusy = true; seekStart = performance.now(); v.currentTime = t;
    }
    function seekFertig() {
      seekMessen();
      seekBusy = false;
      if (pendingTime !== null) { var t = pendingTime; pendingTime = null; requestSeek(t); }
    }
    function seekAus() { seekBusy = false; pendingTime = null; seekStart = 0; }
    video.addEventListener('seeked', seekFertig);
    video.addEventListener('error', seekAus);
    if (mobil) { mobil.addEventListener('seeked', seekFertig); mobil.addEventListener('error', seekAus); }

    function seekMessen() { seekStart = 0; }

    /* Im Hochformat wird das Video NICHT gesprungen, sondern gefahren.
       Grund, gemessen: hero-mobil.mp4 hat praktisch nur einen Keyframe am
       Anfang. Ein Sprung muss deshalb vom Dateianfang bis zur Zielstelle
       dekodieren — auf einem schnellen Rechner 9 ms am Anfang und 105 ms am
       Ende, auf einem Telefon ein Vielfaches davon. Springen ruckelt dort also
       zwangslaeufig. (Der Desktop-Clip heisst nicht umsonst hero-scrub-g8: er
       traegt alle 8 Bilder einen Keyframe und springt in 13-28 ms.)

       Stattdessen laeuft das Video vorwaerts, und das Scrollen bestimmt nur das
       Tempo: liegt der Scrollstand vor dem Video, wird schneller abgespielt;
       hat das Video aufgeholt, haelt es an. Das ist genau das, was Telefone gut
       koennen, und braucht keinen einzigen Sprung.

       Nur beim Zurueckscrollen bleibt ein Sprung noetig; der wird auf einen
       alle 400 ms begrenzt. Verbietet das Geraet das Abspielen (iOS-Stromspar-
       modus), wird ersatzweise gesprungen — langsam, aber nicht bewegungslos. */
    var letzterSprung = 0, abspielenGesperrt = false;
    function mobilFolgen(p) {
      if (!mobil || !mobil.duration || aktivesVideo === video) return;
      var ziel = p * mobil.duration, diff = ziel - mobil.currentTime, jetzt = performance.now();
      if (abspielenGesperrt) {
        if (Math.abs(diff) > 0.12 && jetzt - letzterSprung > 250) { letzterSprung = jetzt; requestSeekAuf(mobil, ziel); }
        return;
      }
      if (diff > 0.04) {
        mobil.playbackRate = Math.max(0.5, Math.min(4, 1 + diff * 2.2));
        if (mobil.paused) {
          var q = mobil.play();
          if (q && q.catch) { q.catch(function () { abspielenGesperrt = true; }); }
        }
      } else if (diff < -0.25) {
        if (!mobil.paused) mobil.pause();
        if (jetzt - letzterSprung > 400) { letzterSprung = jetzt; requestSeekAuf(mobil, ziel); }
      } else if (!mobil.paused) {
        mobil.pause();
      }
    }
    function requestSeekAuf(v, t) {
      if (seekBusy) { pendingTime = t; return; }
      seekBusy = true; v.currentTime = t;
    }

    var loadK = 0, lastDot = -1, lastGlob = -1, lastAtEnd = null, lastP = -1;
    function updateCaptions(p) {
      bands.forEach(function (bd) {
        var a = bd.a, b = bd.b, f = Math.min(0.02, (b - a) / 3);
        var op = (bd.first ? 1 : smoothstep(p, a, a + f)) * (bd.last ? 1 : (1 - smoothstep(p, b - f, b)));
        op = Math.round(op * 200) / 200;
        var k = clamp((p - a) / (bd.ramp || Math.min(0.025, (b - a) * 0.35)), 0, 1);
        if (bd.first) k = Math.max(k, loadK);
        k = Math.round(k * 125) / 125;
        if (op !== bd.op) { bd.el.style.opacity = op; bd.op = op; }
        if (Math.abs(k - bd.k) >= 0.008 || (k === 1 && bd.k !== 1) || (k === 0 && bd.k !== 0)) { bd.el.style.setProperty('--k', k); bd.k = k; }
        if (bd.last) {
          var ks = clamp((k - 0.66) * 4, 0, 1);
          if (ks !== bd.ks) { bd.el.style.setProperty('--ks', ks.toFixed(3)); bd.ks = ks; }
        }
      });
      var dot = 0;
      for (var i = 1; i < edges.length; i++) { if (p >= edges[i] - 0.03) dot = i; }
      if (dot !== lastDot) { dots.forEach(function (d, i) { d.classList.toggle('is-on', i === dot); }); lastDot = dot; }
      if (globulus && globulus.parentElement) {
        var g = Math.round(p * 400) / 400;
        if (g !== lastGlob) { globulus.style.transform = 'translateY(' + ((globulus.parentElement.clientHeight - 14) * g).toFixed(1) + 'px)'; lastGlob = g; }
      }
      var pq = Math.round(p * 200) / 200;
      if (pq !== lastP) { stage.style.setProperty('--eh-p', pq); lastP = pq; }
      var atEnd = p > 0.9;
      if (atEnd !== lastAtEnd) { stage.classList.toggle('at-end', atEnd); lastAtEnd = atEnd; }
    }

    var target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true;
    function tick(now) {
      var dt = Math.min(100, now - (lastTick || now)); lastTick = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      var ausgependelt = Math.abs(target - shown) < 0.0005;
      if (ausgependelt) shown = target;
      /* Die Schleife darf erst enden, wenn auch das Handy-Video eingeholt hat.
         Sonst liefe es unbeaufsichtigt mit bis zu vierfachem Tempo weiter, bis
         es am Ende anschlaegt — mobilFolgen haelt es an, wird aber nur hier
         aufgerufen. */
      if (ausgependelt && (!mobil || mobil.paused)) { rafId = null; lastTick = 0; }
      else { rafId = requestAnimationFrame(tick); }
      requestSeek(shown * (aktivesVideo ? aktivesVideo.duration || 0 : 0));
      mobilFolgen(shown);
      updateCaptions(shown);
    }
    function onScroll() {
      checkSticky(); applyFixedMode();
      target = heroProgress();
      if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { heroOnScreen = es[0].isIntersecting; if (heroOnScreen) onScroll(); }, { threshold: 0 }).observe(hero);
    }

    var inited = false;
    function initHeroOnce() {
      if (inited) return; inited = true;
      if (POSTER_URL) posterLayer.style.backgroundImage = "url('" + POSTER_URL + "')";
      if (!VIDEO_URL) { failVideo(); return; }
      var started = false;
      var start = function () {
        if (started) return; started = true;
        loadHeroBlob().catch(function () {
          try { video.src = VIDEO_URL; video.load(); armVideo(); } catch (e) { failVideo(); }
        });
      };
      if (POSTER_URL) { var im = new Image(); im.onload = start; im.onerror = start; im.src = POSTER_URL; } else { start(); }
      setTimeout(start, 4000);
    }
    function armVideo() {
      video.addEventListener('canplay', function () { requestSeek(heroProgress() * video.duration); stage.classList.add('video-ready'); }, { once: true });
      video.addEventListener('error', failVideo, { once: true });
    }
    function loadHeroBlob() {
      var ctrl = new AbortController(), watchdog = setTimeout(function () { ctrl.abort(); }, 20000);
      return fetch(VIDEO_URL, { signal: ctrl.signal }).then(function (res) {
        if (!res.ok || !res.body) throw new Error('video');
        var total = Number(res.headers.get('Content-Length')) || 6000000;
        var reader = res.body.getReader(), chunks = [], got = 0, lastRing = 0;
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return;
            clearTimeout(watchdog); watchdog = setTimeout(function () { ctrl.abort(); }, 20000);
            chunks.push(r.value); got += r.value.length;
            var frac = Math.min(1, got / total), now = performance.now();
            if (now - lastRing > 100 || frac === 1) { lastRing = now; if (ring) ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
            return pump();
          });
        }
        return pump().then(function () {
          clearTimeout(watchdog);
          if (ring) ring.style.setProperty('--ld', 0);
          video.src = URL.createObjectURL(new Blob(chunks)); video.load(); armVideo();
        });
      });
    }
    function failVideo() { if (ring) ring.style.opacity = 0; stage.classList.add('video-failed'); }

    /* Dasselbe wie loadHeroBlob, nur ohne Ladering — fuer die kurze
       Hochformat-Fassung. Als Blob springt das Video lokal statt am Netz. */
    function ladeAlsBlob(url) {
      var ctrl = new AbortController(), watchdog = setTimeout(function () { ctrl.abort(); }, 20000);
      return fetch(url, { signal: ctrl.signal }).then(function (res) {
        if (!res.ok) throw new Error('video');
        return res.blob();
      }).then(function (b) { clearTimeout(watchdog); return URL.createObjectURL(b); },
              function (e) { clearTimeout(watchdog); throw e; });
    }

    function loadRamp() {
      var t0 = performance.now(), dur = 1400;
      (function step(now) {
        var t = clamp((now - t0) / dur, 0, 1);
        loadK = 1 - Math.pow(1 - t, 3);
        updateCaptions(shown);
        if (t < 1) requestAnimationFrame(step);
      })(t0);
    }

    /* Aktionsleiste und Theme-Kopf (Logo, Menue, Warenkorb) liegen ueber der
       Buehne. Im Hochformat muss der Text darunter beginnen, sonst steht er auf
       dem Logo. --eh-kopf-h ist die gesamte Hoehe dieser Kopfzone.
       Das Logo ragt in manchen Themes ueber den Kasten des Kopfes hinaus,
       deshalb wird die unterste Kante aller sichtbaren Kindelemente gesucht.
       Gemessen wird nur ganz oben auf der Seite, sonst waere der Wert verschoben.

       Gezaehlt wird ab Oberkante der Buehne, nicht ab Fensterrand: die Buehne
       beginnt unter der Aktionsleiste, klebt spaeter aber ganz oben. --eh-oben
       ist genau dieser Abstand; er polstert die Buehne unten aus, damit die
       Karte auch beim ersten Blick vollstaendig im Bild steht. */
    function kopfMessen() {
      if (window.scrollY > 4) return;
      var kopf = document.querySelector('#header') || document.querySelector('header');
      var unten = 0;
      if (kopf && getComputedStyle(kopf).display !== 'none') {
        unten = kopf.getBoundingClientRect().bottom;
        var kinder = kopf.getElementsByTagName('*');
        for (var i = 0; i < kinder.length; i++) {
          var r = kinder[i].getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.bottom > unten) unten = r.bottom;
        }
      }
      var oben = hero ? Math.max(0, hero.getBoundingClientRect().top) : 0;
      root.style.setProperty('--eh-oben', Math.round(oben) + 'px');
      root.style.setProperty('--eh-kopf-h', Math.max(60, Math.min(260, Math.round(unten - oben))) + 'px');
    }
    kopfMessen();
    addEventListener('resize', kopfMessen);
    addEventListener('load', kopfMessen);
    setTimeout(kopfMessen, 900);
    setTimeout(kopfMessen, 2600);

    /* Drei Betriebsarten.
       scrub     = Desktop, das Breitbild-Video folgt dem Scrollen.
       blaettern = Hochformat am Handy und Tablet, aber nur wenn die Einstellung
                   „Scroll-Animation am Handy" an ist. Dieselben Textbeats folgen
                   dem Scrollen, die kurze Fassung in der Karte laeuft mit. Ist
                   sie aus (Vorgabe), gilt auch im Hochformat standbild — dann
                   wird das Handy-Video gar nicht erst geladen.
       standbild = flaches Querformat und "Bewegung reduzieren", nur ein Bild.
       Die Abfragen stehen wortgleich in ee-scroll-hero.css und ee-scroll-hero-mobil.css.
       Die Reihenfolge hier entspricht der Reihenfolge der Bloecke im Hochformat-CSS. */
    var GATES_STANDBILD = ['(orientation: landscape) and (pointer: coarse) and (max-height: 560px)', '(prefers-reduced-motion: reduce)'];
    var GATES_BLAETTERN = ['(max-width: 720px)', '(orientation: portrait) and (max-width: 1024px)', '(orientation: portrait) and (pointer: coarse)'];
    var GATES = GATES_STANDBILD.concat(GATES_BLAETTERN);
    function passt(q) { return matchMedia(q).matches; }
    function modus() {
      if (GATES_STANDBILD.some(passt)) return 'standbild';
      if (GATES_BLAETTERN.some(passt)) return HANDY_ANIM ? 'blaettern' : 'standbild';
      return 'scrub';
    }

    /* Das Hochformat-Video laedt erst, wenn der Held wirklich im Bild ist —
       sonst zahlt jeder Besucher Daten fuer etwas, das er nie sieht. Bis dahin
       zeigt das Poster-Attribut das Startbild; scheitert das Laden ganz, bleibt
       das Endbild sichtbar, das die Karte als Hintergrund traegt.

       iOS zeichnet einen gesprungenen Einzelbild erst, wenn das Video einmal
       gelaufen ist. Deshalb wird es nach dem Laden kurz angespielt und sofort
       wieder angehalten. */
    var mobilGeladen = false, beobachter = null;
    function mobilQuelle() { return mobil ? mobil.getAttribute('data-src') || '' : ''; }
    function mobilVorspannen() {
      if (!mobil) return;
      var p = mobil.play();
      if (p && p.then) {
        p.then(function () { mobil.pause(); mobilFolgen(shown); },
               function () { abspielenGesperrt = true; mobilFolgen(shown); });
      } else { mobilFolgen(shown); }
    }
    function mobilLaden() {
      if (!mobil || mobilGeladen) return;
      mobilGeladen = true;
      var quelle = mobilQuelle();
      if (!quelle) return;
      mobil.addEventListener('loadeddata', mobilVorspannen, { once: true });
      ladeAlsBlob(quelle).then(function (u) { mobil.src = u; mobil.load(); },
                               function () { mobil.src = quelle; mobil.load(); });
    }
    function mobilBeobachten() {
      if (!mobil || mobilGeladen || beobachter) return;
      if (!('IntersectionObserver' in window)) { mobilLaden(); return; }
      beobachter = new IntersectionObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (eintraege[i].isIntersecting) { mobilLaden(); mobilLoesen(); return; }
        }
      }, { threshold: 0.2 });
      beobachter.observe(hero);
    }
    function mobilLoesen() { if (beobachter) { beobachter.disconnect(); beobachter = null; } }
    var scrubOn = false;
    function enableScrub() {
      if (scrubOn) return; scrubOn = true;
      if (stickyGebrochen()) fixedModeAn();
      if (aktivesVideo === video) initHeroOnce();
      addEventListener('scroll', onScroll, { passive: true });
      bands.forEach(function (b) { b.op = -1; b.k = -1; b.ks = -1; });
      lastDot = -1; lastGlob = -1;
      updateCaptions(heroProgress()); onScroll();
      if (loadK < 1) loadRamp();
    }
    function disableScrub() {
      if (!scrubOn) return; scrubOn = false;
      removeEventListener('scroll', onScroll);
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    }
    function pinToFinalStates() {
      bands.forEach(function (b) { b.el.style.setProperty('--k', 1); b.el.style.setProperty('--ks', 1); b.k = 1; });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === dots.length - 1); });
    }
    function applyHeroMode() {
      var m = modus();
      if (m === 'scrub') { aktivesVideo = video; mobilLoesen(); enableScrub(); return; }
      if (m === 'blaettern') {
        aktivesVideo = null;   /* gesprungen wird hier nicht, siehe mobilFolgen */
        mobilBeobachten();
        enableScrub();
        return;
      }
      disableScrub();
      pinToFinalStates();
      mobilLoesen();
    }
    GATES.map(function (q) { return matchMedia(q); }).forEach(function (m) {
      if (m.addEventListener) m.addEventListener('change', applyHeroMode); else m.addListener(applyHeroMode);
    });
    addEventListener('resize', function () { lastGlob = -1; if (scrubOn) onScroll(); });
    applyHeroMode();
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-eh]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
